import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_PAYMENT_TOOLS_URL } from "../constants"
import { IErrorResponse, ILinkingStatusResponse } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export async function paymentStatusRequest(
  linkAccountRequestId: string | undefined,
  token: string | null,
) {
  const response = await axios(
    `${API_PAYMENT_TOOLS_URL}/link-requests/${linkAccountRequestId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  )

  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка")
  }

  return response.data
}

export const useLinkRequestById = (
  linkAccountRequestId?: string | undefined,
) => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<ILinkingStatusResponse, IErrorResponse>({
    queryKey: ["linking-status", linkAccountRequestId],
    queryFn: () => paymentStatusRequest(linkAccountRequestId, token),
    enabled: !!linkAccountRequestId,
    refetchInterval: 1500,
    refetchOnWindowFocus: false,
  })
}
